import { render, staticRenderFns } from "./NotFound.view.vue?vue&type=template&id=5083d77a&scoped=true&"
import script from "./NotFound.view.vue?vue&type=script&lang=js&"
export * from "./NotFound.view.vue?vue&type=script&lang=js&"
import style0 from "./NotFound.view.vue?vue&type=style&index=0&id=5083d77a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5083d77a",
  null
  
)

export default component.exports